import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';
import { PaymentRequest } from './payment.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(private http: HttpClient) {}

  createPayment(payment: PaymentRequest, recaptchaToken: any = '') {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-recaptcha-token': recaptchaToken
    });
    return this.http
      .post<any>(environment.serverUrl + `public/payment-request/`, payment, {
        headers: headers
      })
      .pipe(
        map((response: any) => {
          console.log('Payment Response => ', response);
          return response;
        })
      );
  }

  createSetupIntent(payment: PaymentRequest) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .post<any>(environment.serverUrl + `public/create-setup-intent/`, payment, {
        headers: headers
      })
      .pipe(
        map((response: any) => {
          console.log('Payment Response => ', response);
          return response;
        })
      );
  }

  savedVerifiedCard(paymentData: any, tempPaymentId: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .post<any>(environment.serverUrl + `public/update-payment-temp/${tempPaymentId}`, paymentData, {
        headers: headers
      })
      .pipe(
        map((response: any) => {
          console.log('Payment Response => ', response);
          return response;
        })
      );
  }
}
